import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import auth from './modules/auth'
import competitions from './modules/competitions'
import errors from './modules/errors'
import passcode from './modules/passcode'
import players from './modules/players'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    auth,
    competitions,
    errors,
    passcode,
    players
  }
})
